import styled from "styled-components";

import { FlexDiv } from "../../components/Atoms";

export const PostWrapper = styled(FlexDiv)`
  flex-direction: column;
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  overflow: auto;
  gap: 12px;
  padding: 16px 24px;
`;
